import { Box, Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import { useRef, useState } from "react"
import { Constants, Format } from "../../../../../../../utils"
import { RepeatButton } from "../../../../../../../components/repeatButton"
import useAuth from "../../../../../../../context/auth"
import { useNavigate } from "react-router-dom"

interface Props {
    open: boolean,
    onClose: () => void
}

export const ModalSimulator = ({
    onClose,
    open
}: Props) => {
    const { user } = useAuth()
    const navigate = useNavigate()
    const maxValue = Constants.creditEvolution[(user?.client?.actualTable ?? 1) - 1]
    const minValue = 300

    const [value, setValue] = useState(maxValue)

    const valueRef = useRef(value)
    valueRef.current = value

    const handleValueChange = (increment: boolean) => {
        if (increment ? valueRef.current < maxValue : valueRef.current > minValue) {
            setValue((prev) => {
                const newValue = increment ? prev + 100 : prev - 100;
                return newValue;
            });
        }
    };

    return (
        <ModalComponent
            open={open}
            onClose={onClose}
            title="Solicitação"
            description="Qual valor você deseja?"

        >
            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "3rem",
                }}>

                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1rem"
                    }}
                >
                    <RepeatButton
                        variant="outlined"
                        sx={{
                            width: "6.5rem",
                            height: "3.4rem",
                        }}
                        onClick={() => handleValueChange(false)}
                        disabled={value <= minValue}
                    >
                        -100
                    </RepeatButton>
                    <Grid
                        sx={{
                            minWidth: "14.5rem",
                            height: "6.7rem",
                            borderRadius: "10px",
                            backgroundColor: "rgba(0, 0, 0, 0.10)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography fontWeight={800} fontSize={"3rem"}>{Format.currencyWithoutDecimals(value)}</Typography>
                    </Grid>

                    <RepeatButton
                        variant="outlined"
                        sx={{
                            width: "6.5rem",
                            height: "3.4rem",
                        }}
                        onClick={() => handleValueChange(true)}
                        disabled={value >= maxValue}
                    >
                        +100
                    </RepeatButton>
                </Grid>

                <Button
                    variant="contained"
                    sx={{
                        width: "100%",
                        maxWidth: "27.5rem",
                        height: "4rem",
                    }}
                    onClick={() => {
                        navigate("simulador", {
                            state: {
                                value
                            }
                        })
                    }}
                >Solicite seu crédito aqui</Button>

            </Grid>
        </ModalComponent>
    )
}